import { render, staticRenderFns } from "./ParentsDashboard.vue?vue&type=template&id=6daa68c2&scoped=true"
import script from "./ParentsDashboard.vue?vue&type=script&lang=ts"
export * from "./ParentsDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daa68c2",
  null
  
)

export default component.exports